import axios from 'axios';
import { CustomSingleSelectModel } from '../components/CustomSingleSelect';
import { Helpers } from '../helpers/Helpers';
import { AddAntrepoInRequest } from '../models/request/antrepoIn/AddAntrepoInRequest';
import { GetAntrepoInListPagingAndFilterRequest } from '../models/request/antrepoIn/GetAntrepoInListPagingAndFilterRequest';

export class AntrepoInService {
    static async getAntrepoInList(_selectedReceiverFirm: CustomSingleSelectModel | undefined) {
        try {
            var inputObj = {
                selectedReceiverFirm: _selectedReceiverFirm
            };

            console.log('SERVICE CALL - getAntrepoInList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/getAntrepoInList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAntrepoInList(inputObj: GetAntrepoInListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAntrepoInList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/exportAntrepoInList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoInListPagingAndFilter(inputObj: GetAntrepoInListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAntrepoInListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/GetAntrepoInListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addAntrepoIn(inputObj: AddAntrepoInRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddAntrepoIn', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/AddAntrepoIn', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAntrepoIn(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAntrepoIn', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/deleteAntrepoIn', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoInById(_id: string | null) {
        try {
            var inputObj = {
                id: _id,
            };

            console.log('SERVICE CALL - getAntrepoInById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/getAntrepoInById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoInByAntrepoOfferId(_antrepoOfferId: string) {
        try {
            var inputObj = {
                antrepoOfferId: _antrepoOfferId
            };

            console.log('SERVICE CALL - getAntrepoInByAntrepoOfferId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/getAntrepoInByAntrepoOfferId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAntrepoInByTransferAntrepoOutId(_transferAntrepoOutId: string) {
        try {
            var inputObj = {
                transferAntrepoOutId: _transferAntrepoOutId
            };

            console.log('SERVICE CALL - getAntrepoInByTransferAntrepoOutId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/getAntrepoInByTransferAntrepoOutId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }


    static async getAntrepoInByRedreseAntrepoInId(_RedreseAntrepoInId: string) {
        try {
            var inputObj = {
                RedreseAntrepoInId: _RedreseAntrepoInId
            };

            console.log('SERVICE CALL - getAntrepoInByRedreseAntrepoInId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/AntrepoIn/getAntrepoInByRedreseAntrepoInId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

}